import { HStack } from '@rbilabs/universal-components';

import Link from 'components/link';
import { primitive } from 'styles/constants';

export const StyledLink = Link.withConfig({
  borderBottomWidth: '1px',
  borderStyle: 'solid',
  borderBottomColor: `${primitive.$greyFour}`,
  width: '100%',
  color: primitive.$greyOne,
  paddingX: '0',
  paddingY: '5',
  _web: {
    cursor: 'pointer',
  },
});

export const Row = HStack.withConfig({
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});
